export class ClassAssignment {
    StartDate: string;
    EndDate: string;
    OrganizationID: number;
    AssignmentName: string;
    AssignmentID: string;
    ActivitySequence: ActivitySequence = new ActivitySequence();
}

export class ActivitySequence {
    ActivitySequenceID: string;
    Name: string;
    Activities: Activity[] = [];
}

export class Activity {
    ActivityID: string;
    UnitNumber: number;
}
